







import { Component, Vue, Prop} from "vue-property-decorator";

@Component({})

export default class CrossIcon extends Vue {
  /* Props */
  @Prop({ default: "#88889D" })
  public color!: string;
}
